module.exports = __webpack_public_path__ + "img/3.f75a103c.png";